<template>
  <div class="queryContent">
    <!-- <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("query.type.rules") }} </BreadcrumbItem>
      </Breadcrumb>
    </div> -->
    <div class="query-header scroll-border-dom">
      <div class="query-header-wrap ">
        <div class="query-tp boxshadow1">
          <div class="query-slogon">{{ $t("query.type.rules") }}</div>
          <Tabs v-model="currentQueryType" @on-click="onTabSwitch">
            <TabPane label="进口查询" name="import" icon="logo-tux"></TabPane>
            <TabPane
              label="出口查询"
              name="export"
              icon="logo-windows"
            ></TabPane>
          </Tabs>
        </div>
        <div class="inputs-wrap boxshadow1">
          <div class="query-inputs">
            <div class="inputs clearfix" @keyup="escEvent">
              <template v-if="currentQueryType == 'import'">
                <Export
                  class="ex"
                  ref="ex"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Export>
                <Import
                  class="im"
                  ref="im"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Import>
                <Product
                class="pr"
                ref="pr"
                placeholderText="商品编码/商品名称"
                :currentState="currentState"
                styleName="n"
                :countrycode="countrycode"
                @handleClick="handleClick"
                @closeDropdown="closeDropdown"
              ></Product>
              </template>
              <template v-else>
                <Export
                  class="ex"
                  ref="ex"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Export>
                <Import
                  class="im"
                  ref="im"
                  :width="'200%'"
                  :currentState="currentState"
                  styleName="n"
                  @handleClick="handleClick"
                  @closeDropdown="closeDropdown"
                ></Import>
                <Product
                class="pr"
                ref="pr"
                placeholderText="商品编码/商品英文名称"
                :currentState="currentState"
                styleName="n"
                :countrycode="countrycode"
                @handleClick="handleClick"
                @closeDropdown="closeDropdown"
              ></Product>
              </template>
           
            </div>
            <div class="btn-wrap clearfix">
              <Button
                type="primary"
                class="btn search"
                @click.prevent="searchHandle"
              >
                <span v-if="!isShowLoader"><span>搜索</span></span>
                <span v-else>{{ $t("common.loading") }}</span>
              </Button>
              <Button
                class="btn reset"
                type="primary"
                @click.prevent="resetHandle"
                :disabled="isShowLoader"
                ><span>{{ $t("btn.reset") }}</span></Button
              >
            </div>
            <!-- <Watermark></Watermark> -->
          </div>
        </div>
      </div>
    </div>

    <div class="results">
      <div class="results-wrap">
        <div class="tabs-content boxshadow1" v-if="!_.isEmpty(ftas)">
          <div
            class="breadcrumbs ellipsis"
            v-if="!_.isEmpty(exporterData) && !isShowStay"
          >
            <Tooltip transfer   v-if="currentQueryType === 'import'">
              <span
                v-html="
                  $t('query.result.rules.breadcrumbs', {
                    from: exporterData.name,
                    to: importerData.name,
                    product: `${_.truncate(hsData.name, { length: 30 })} (${
                      hsData.code
                    })`
                  })
                "
              ></span>
              <div
                slot="content"
                style="text-align:center;font-size:13px;white-space:normal;line-height: 20px;"
              >
                <p
                  v-html="
                    $t('query.result.rules.breadcrumbs', {
                      from: exporterData.name,
                      to: importerData.name,
                      product: `${hsData.name} (${hsData.code})`
                    })
                  "
                ></p>
              </div>
            </Tooltip>
            
            <Tooltip transfer v-else>
              <span
                v-html="
                  $t('query.result.rules.breadcrumbs', {
                    from: importerData.name,
                    to: exporterData.name,
                    product: `${_.truncate(hsData.name, { length: 30 })} (${
                      hsData.code
                    })`
                  })
                "
              ></span>
              <div
                slot="content"
                style="text-align:center;font-size:13px;white-space:normal;line-height: 20px;"
              >
                <p
                  v-html="
                    $t('query.result.rules.breadcrumbs', {
                      from: exporterData.name,
                      to: importerData.name,
                      product: `${hsData.name} (${hsData.code})`
                    })
                  "
                ></p>
              </div>
            </Tooltip>





          
            <a
              class="query-rate"
              href="#"
              @click.stop.prevent="
                jfNotice($event, {
                  name: 'queryRates',
                  params: {
                    exporter: exporterData.id,
                    importer: importerData.id,
                    hscode: hsData.code
                  }
                })
              "
              >{{ $t("query.result.other.seeftaofproduct") }}</a
            >
          </div>
          <Tabs v-model="tabID">
            <TabPane
              :label="item.name"
              :name="`t${item.id}`"
              v-for="(item, index) in ftas"
              :key="'search-rules-' + index"
            >
              <section>
                <div class="caption">
                  {{ $t("query.result.rules.origin.title") }}
                  <span class="desc">{{
                    $t("query.result.rules.origin.desc")
                  }}</span>
                </div>
                <div class="cell">
                  <ul class="number-list" v-if="!_.isEmpty(item.criterion)">
                    <li
                      v-for="(item, index) in item.criterion"
                      :key="`rules-content-crit-${index}`"
                    >
                      <span class="sn">{{ index + 1 }}</span>
                      <span class="name">{{ item.name }}</span>
                      <p class="desc">{{ item.description }}</p>
                    </li>
                  </ul>
                  <div class="nodata" v-else>
                    {{ $t("query.result.rules.noRules") }}
                  </div>
                </div>
              </section>
            </TabPane>
          </Tabs>
        </div>

        <div class="results-content">
          <div style="position: relative" v-if="ftas.length > 0">
            <Tabs v-model="tabID">
              <TabPane
                :label="item.name"
                :name="`t${item.id}`"
                v-for="(item, index) in ftas"
                :key="'search-rules-' + index"
              >
                <RulesContent
                  class="rules-content"
                  :_id="item.id"
                  :ranks="ranks"
                  :dataSet="item"
                />
              </TabPane>
            </Tabs>
          </div>
          <RulesContent
            class="rules-content"
            style="margin-left:-4px;margin-right:-4px"
            v-else
          />
        </div>
        <Statement></Statement>
      </div>

      <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Export from "../common/Export";
import Import from "../common/Import";
import Product from "../common/Product";
import RulesContent from "./RulesContent";
import Loader from "../layout/Loader";
import Statement from "@/components/layout/statement";
import { createNamespacedHelpers } from "vuex";
const {
  mapState: mapSearchState,
  mapMutations: mapSearchMutations
} = createNamespacedHelpers("search");
const {
  mapState: mapDataState,
  mapGetters: mapDataGetters
} = createNamespacedHelpers("data");

export default {
  name: "Rules",
  props: ["exporter", "importer", "hscode"],
  components: { Import, Export, Product, RulesContent, Loader, Statement },
  data() {
    return {
      changeTab: "",
      countrycode: 27,
      currentQueryType: "import",
      $isIE: Vue._customVars.isIE,
      stayData: {
        import: ["中国"],
        exporter: [
          "新西兰",
          "秘鲁",
          "哥斯达黎加",
          "冰岛",
          "格鲁吉亚",
          "中国香港",
          "中国澳门"
        ]
      },
      isShowStay: false,
      searchItem: {},
      tabID: this.$route.query.tab ? `t${this.$route.query.tab}` : "",
      isShowLoader: false,
      importerData: {},
      exporterData: {},
      hsData: {},
      ftas: [],
      ranks: [],
      t: "",
      searchDoing: false,
      isShowSearchMsg: true
    };
  },
  watch: {
    productReady(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.initInputValue();
        }, 200);
      }
    },
    exporter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    importer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    hscode(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    $route() {
      this.t = this.$route.query._t;
    },
    t(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    }
  },
  computed: {
    currentState: {
      get() {
        return this.getActiveName();
      },
      set(v) {
        this.updateState(v);
      }
    },
    ...mapSearchState({
      historyExportItem: state => state.history.exporter,
      historyImportItem: state => state.history.importer,
      historyProductItem: state => state.history.products
    }),
    apiPrice() {
      if (this._.isEmpty(this.apiValue)) {
        return null;
      } else {
        return this.getApiValue();
      }
    },
    ...mapDataState(["productReady"]),
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  created() {
    this.currentState = "rules";
    this.requestData();
  },
  mounted() {
    let chana = { id: 27, text: "中国" };
    this.$refs.im.isRead = true;
    this.$refs.im.setDefaultValue(chana);
     this.$nextTick(() => {
      this.currentState = 'rules'
      if (!this._.isEmpty(this.getTopProduct()())) {
        this.initInputValue()
      }
       if (this.$route.params.hscode != 1) {
        this.$refs.pr.setDefaultValue({ id: this.$route.params.hscode });
      }
      if (this.$route.params.exporter != 1) {
      
        this.$refs.ex.setDefaultValue({
          id: this.$route.params.exporter,
          text: this.$route.query.text
        });
      }

      this.$root.$on('QuickShowEvent', () => {
        this.currentState = 'rules'
        try {
          this.closeAllDropdown(!this.$data.$isIE)
        } catch (e) {}
      })
      let queryHeaderDom = document.querySelector('.query-header')
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      resultDom.style.minHeight = (this._h.getWinHeight() - this._h.getOuterElSize(footer).height - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(queryHeaderDom).bottom))) + 'px'
    })
  },
  methods: {
   onTabSwitch() {
      if (this.changeTab !== this.currentQueryType) {
      
        let chana = { id: 27, text: "中国" };
        if (this.currentQueryType === "import") {
          this.countrycode = 27;
          this.$refs.ex.isRead = false;
          if (this.$refs.im.value.id != chana.id) {
            this.$refs.ex.setDefaultValue(this.$refs.im.value);
          }
          this.$refs.im.isRead = true;
          this.$refs.im.setDefaultValue(chana);
        } else if (this.currentQueryType === "export") {
          this.$refs.im.isRead = false;
          this.countrycode = 27;
          if (this.$refs.ex.value.id != chana.id) {
            this.$refs.im.setDefaultValue(this.$refs.ex.value);
          }
          this.$refs.ex.isRead = true;
          this.$refs.ex.setDefaultValue(chana);
        }
        setTimeout(() => {
          if (this.$route.params.hscode != 1) {
          this.$refs.pr.setDefaultValue({ id: this.$route.params.hscode });
          }
          
        }, 100);

       

        this.best = {};
        this.ranks = [];
        this.hsData = {};
        this.ftas = [];
        this.importerData = {};
        this.exporterData = {};
      }
      this.changeTab = this.currentQueryType;
    },
    jfNotice(event, params) {
      if (this.$i18n.locale !== "zh-CN") {
        this.$router.push(params);
        return;
      }
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(1);
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(
              `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
              status => {
                if (status) {
                  this.$router.push(params);
                }
              }
            );
          } else {
            this.$router.push(params);
          }
        } else {
          this.$router.push(params);
        }
      });
    },
    delayRequestData() {
      setTimeout(() => {
        this.requestData();
      }, 500);
    },
    requestData() {
      if (this.isShowLoader) {
        // this.delayRequestData()
        return;
      }
      if (this.importer == 1 && this.hscode == 1 && this.exporter == 1) return;
      this.$Loading.start();
      this._h.scrollTop();
      this.isShowLoader = true;
      this.isShowStay = false;
      let params1 = this.importer;
      let params2 = this.exporter;

        
    
   
      this.$api.query.rule(params1, params2, this.hscode, {
        success: response => {
          this.$Loading.finish();
          this.$refs.pr && this.$refs.pr.closeDowndown(false);
          if (response.data.code === 200) {
            if (
              this._.isEmpty(response.data.data.ftas) ||
              (response.data.data.ftas.length === 1 &&
                !response.data.data.ftas[0].transportation &&
                !response.data.data.ftas[0].document &&
                !response.data.data.ftas[0].criterion &&
                !response.data.data.ftas[0].additional)
            ) {
              if (
                this._.indexOf(this.stayData.exporter, this.$refs.ex.text) !==
                  -1 &&
                this._.indexOf(this.stayData.import, this.$refs.im.text) !== -1
              ) {
                this.isShowStay = true;
                this.ftas = [];
              } else {
                this.$Message.warning({
                  content: this.$t("query.message.search_none"),
                  closable: true
                });
              }
            } else {
              this.importerData = response.data.data.importer;
              this.exporterData = response.data.data.exporter;
              this.hsData = response.data.data.hs;
              this.ftas = response.data.data.ftas;
              this.ranks = response.data.data.ranks;
            
            
              if(response.data.data.hs && response.data.data.hs.code ){
              
                this.$refs.pr.setDefaultValue({
                  id: response.data.data.hs.code,
                  text: response.data.data.hs.name
                },true);
              
              }
              // if(this.importerData && this.importerData.id ){
              //   this.$refs.im.setDefaultValue({
              //     id: this.importerData.id,
              //     text: this.importerData.name
              //   },true)
              // }


              if( this.currentQueryType === "import"){

                if(this.exporterData && this.exporterData.id ){
                this.$refs.ex.setDefaultValue({
                  id: this.exporterData.id,
                  text: this.exporterData.name
                },true)
                 }

              }

              if( this.currentQueryType === "export"){
             

                if(this.exporterData && this.exporterData.id ){
                this.$refs.im.setDefaultValue({
                  id: this.exporterData.id,
                  text: this.exporterData.name
                },true)
                }

                }

             

              setTimeout(() => {
                this.closeAllDropdown(true);
              }, 500);

              // if (this.ftas.length > 1) {
              if (this.ftas.length > 0) {
                let tid = this.$route.query.tab
                  ? this.$route.query.tab
                  : this.ftas[0].id;
                this.tabID = `t${tid}`;
                // setTimeout(() => {
                //   let rulesContent = document.querySelectorAll(
                //     ".rules-content"
                //   );
                //   for (let i = 0; i < rulesContent.length; i++) {
                //     let _id = rulesContent[i].getAttribute("_id");
                //     if (parseInt(_id) === parseInt(tid)) {
                //       rulesContent[i].style.visibility = "visible";
                //     } else {
                //       rulesContent[i].style.visibility = "hidden";
                //     }
                //   }
                // }, 500);
              }
            }
          } else if (response.data.code === 404) {
            if (
              this._.indexOf(this.stayData.exporter, this.$refs.ex.text) !==
                -1 &&
              this._.indexOf(this.stayData.import, this.$refs.im.text) !== -1
            ) {
              this.isShowStay = true;
              this.ftas = [];
            } else {
              this.$Message.warning({
                content: this.$t("query.message.search_none"),
                closable: true
              });
            }
            // } else if (response.data.code === 505) {
            //   this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
          } else if (response.data.code === 401) {
            // this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
            this.$Message.error({
              content: this.$t("query.message.search_perm_limit2"),
              closable: false
            });
            // } else if (response.data.code === 506) {
            //   this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
            this.$Message.warning({content: response.data.message, closable: true})
          }
          this.isShowLoader = false;
        },
        error: errorMsg => {
          this.isShowLoader = false;
          this.$Message.error({
            content: this.$t("common.tryAgain"),
            closable: true
          });
          this.$Loading.error();
        }
      });
    },
    initInputValue() {
      let exporterItem = this.getExporterById()(this.exporter);
      let impoterItem = this.getImporterById()(this.importer);
      let productItem = this.getProductByCode()(this.hscode);
    
      if (
        !this._.isEmpty(exporterItem) &&
        !this._.isEmpty(impoterItem) &&
        !this._.isEmpty(productItem)
      ) {
        this.$refs.ex.setDefaultValue({
          id: exporterItem.id,
          text: exporterItem.name
        });
        this.$refs.im.setDefaultValue({
          id: impoterItem.id,
          text: impoterItem.name
        });
        this.$refs.pr.setDefaultValue({
          id: productItem.code,
          text: productItem.name
        });
        this.searchItem = {
          exporter: exporterItem,
          impoter: impoterItem,
          product: productItem
        };
      } else if (
        !this._.isEmpty(this.historyExportItem) &&
        !this._.isEmpty(this.historyImportItem) &&
        !this._.isEmpty(this.historyProductItem)
      ) {
        // this.$refs.ex.setDefaultValue(this.historyExportItem[0])
        // this.$refs.im.setDefaultValue(this.historyImportItem[0])
        // this.$refs.pr.setDefaultValue(this.historyProductItem[0])
        // this.searchItem = {exporter: this.historyExportItem[0], impoter: this.historyImportItem[0], product: this.historyProductItem[0]}
      }
    },
    resetHandle() {
      this.$refs.ex && this.$refs.ex.resetContent(false);
      this.$refs.im && this.$refs.im.resetContent(false);
      this.$refs.pr && this.$refs.pr.resetContent(false);
    },
    searchByOther(hasDropdown = false) {
      this.searchDoing = false;
      if (this.$refs.ex.text && !this.$refs.ex.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.export_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
        return;
      }
      if (this.$refs.im.text && !this.$refs.im.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.import_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
        return;
      }
      if (this.$refs.pr.text && !this.$refs.pr.value.id) {

        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.product_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
        return;
      }
      this.jfNotice2();
    },
    searchHandle() {
      if (this.searchDoing) return;
      this.searchDoing = true;
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return;
      if (
        this.$refs.ex.isShowDropDown ||
        this.$refs.im.isShowDropDown ||
        this.$refs.pr.isShowDropDown
      ) {
        setTimeout(() => {
          this.searchByOther(true);
        }, 150);
      } else {
        this.searchByOther();
      }
    },
    jfNotice2() {
      if (this.$i18n.locale === "zh-CN") {
        this.GJFNotice(status => {
          if (status) {
            let jf = this.getApiValue()(2);
            if (jf && jf.integral && jf.integral > 0) {
              this.GConfirm(
                `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
                status => {
                  if (status) {
                    this.searchHandleAfter();
                  }
                }
              );
            } else {
              this.searchHandleAfter();
            }
          } else {
            this.searchHandleAfter();
          }
        });
      } else {
        this.searchHandleAfter();
      }
    },
    searchHandleAfter() {
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return;

      this.$refs.ex && this.$refs.ex.setValueFromDefaultPlaceholder();
      this.$refs.im && this.$refs.im.setValueFromDefaultPlaceholder();
      if (!this.$refs.ex.text) {
        this.$Message.warning({
          content: this.$t("query.message.export_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.ex.value.id) {
        this.$Message.warning({
          content: this.$t("query.message.export_error"),
          closable: true
        });
        return;
      }
      if (!this.$refs.im.text) {
        this.$Message.warning({
          content: this.$t("query.message.import_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.im.value.id) {
        this.$Message.warning({
          content: this.$t("query.message.import_error"),
          closable: true
        });
        return;
      }
      if (this.$refs.ex.value.id === this.$refs.im.value.id) {
        this.$Message.warning({
          content: this.$t("query.message.notEqu"),
          closable: true
        });
        return;
      }
      this.$refs.pr && this.$refs.pr.setValueFromDefaultPlaceholder();
      if (!this.$refs.pr.text) {
        this.$Message.warning({
          content: this.$t("query.message.product_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.pr.value.id) {
   
        this.$Message.warning({
          content: this.$t("query.message.product_error"),
          closable: true
        });
        return;
      }
      this.updateHistory({
        exporter: this.$refs.ex.value,
        importer: this.$refs.im.value,
        products: this.$refs.pr.value
      });
    
      switch (this.currentState) {
        case "rules":



        if (this.currentQueryType === "import") {
          this.$router.push({
            name: "queryRules",
            params: {
              exporter: this.$refs.ex.value.id,
              importer: this.$refs.im.value.id,
              hscode: this.$refs.pr.value.id
            },
            query: {
              _t: new Date().getTime()
            }
          });
        
          }
          else{

            this.$router.push({
            name: "queryRules",
            params: {
              exporter: this.$refs.im.value.id,
              importer: this.$refs.ex.value.id,
              hscode: this.$refs.pr.value.id
            },
            query: {
              _t: new Date().getTime()
            }
          });

          }
          
          
          break;
      }
    },
    handleClick(event, componentName) {
      switch (componentName) {
        case "exporter":
          this.$refs.im.closeDowndown(false);
          this.$refs.pr.closeDowndown(false);
          this.$refs.pr && this.$refs.pr.resetContent(false);
          break;
        case "importer":
          this.$refs.ex.closeDowndown(false);
          this.$refs.pr.closeDowndown(false);
          break;
        case "product":
          this.$refs.ex.closeDowndown(false);
          this.$refs.im.closeDowndown(false);
          break;
      }
    },
    enterEvent(event, componentName) {
      switch (componentName) {
        case "ex":
          if (this.$refs.ex.text) {
            this.setAutomatic(componentName);
          }
          break;
        case "im":
          if (this.$refs.im.text) {
            this.setAutomatic(componentName);
          }
          break;
        case "pr":
          if (this.$refs.pr.text) {
            this.setAutomatic(componentName);
          }
          break;
      }
      setTimeout(() => {
        // if (this.$refs.ex.value.id && this.$refs.im.value.id && this.$refs.pr.value.id) {
        this.isShowSearchMsg = false;
        this.searchHandle();
        // }
      }, 300);
    },
    escEvent(event) {
      if (event && event.keyCode === 27) {
        this.closeAllDropdown();
      }
    },
    tabEvent(event, componentName) {
      this.setAutomatic(componentName);
    },
    closeDropdown(event, componentName) {
      this.setAutomatic(componentName, false);
    },
    closeAllDropdown(isBlur = true) {
      this.$refs.ex.closeDowndown(isBlur);
      this.$refs.im.closeDowndown(isBlur);
      this.$refs.pr.closeDowndown(isBlur);
    },
    setAutomatic(componentName, isNextDropDown = true) {
      switch (componentName) {
        case "ex":
          this.$refs.ex.closeDowndown(true);
          if (isNextDropDown || this.$refs.ex.text) {
            if (!this.$refs.im.text) {
              this.$refs.im.inputClick();
            } else if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick();
            }
          }
          break;
        case "im":
          this.countrycode = 27;
          this.$refs.im.closeDowndown(true);
          if (isNextDropDown || this.$refs.im.text) {
            if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick();
            }
          }
          break;
        case "pr":
          this.$refs.pr.closeDowndown(true);
          break;
      }
    },

    ...mapSearchState({
      getActiveName: state => state.activeName
    }),
    ...mapSearchMutations(["updateState", "updateHistory"]),
    ...mapDataGetters([
      "getExporterById",
      "getImporterById",
      "getProductByCode",
      "getTopProduct",
      "getApiValue"
    ])
  }
};
</script>
<style scoped>
.chris_sd {
  position: absolute;
  width: 100px;
  right: 60px;
  top: -25px;
  z-index: 100;
}
.ex,
.im {
  width: 29%;
  float: left;
  border-right: 0 none !important;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.pr {
  width: 42%;
  float: left;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.im {
  border-radius: 0;
}
.results {
  position: relative;
}
.queryContent .query-header-wrap,
.results-wrap {
  width: 1400px; 
  margin: 20px auto ;
  padding: 0 0 20px;
}
.results-wrap {
  margin-top: 0;
}
.query-slogon {
  color: #323232;
  font-weight: bold;
  font-size: 15px;
  padding: 14px 18px 12px;
}
.query-inputs {
  position: relative;
  padding-left: 1px;
  padding: 0 20px;
  padding-right: 310px;
}
.query-inputs .inputs {
  /* width: 65%; */
}
.btn-wrap {
  position: absolute;
  right: 20px;
  margin-left: 8px;
  bottom: 0;
  padding: 3px 0;
  height: 40px;
}
.btn {
  width: 130px;
  border: 1px solid #1f8afd;
  border-radius: 3px;
  height: 100%;
  float: left;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.btn span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn.search {
  border-color: #2f6fb9;
  background-color: #2f6fb9;
  color: #fff;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  letter-spacing: 2px;
}
.btn.ivu-btn-loading {
  cursor: default;
}
.btn.ivu-btn-loading span {
  position: static;
  transform: none;
}
.btn.reset {
  background-color: #fff;
  border-color: #2f6fb9;
  color: #2f6fb9;
  margin-left: 20px;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  letter-spacing: 2px;
}
.btn.reset[disabled] {
  color: #bbbec4;
  border-color: #dddee1;
  cursor: default;
}
.results {
  /* background-color: #fff; */
  position: relative;
  margin-top: 30px;
}
.results-wrap {
  padding-left: 1px;
}
.boxshadow1 {
  background: #fff;
}
.shadow-divide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
  z-index: 1;
  height: 5px;
  background-color: #fff;
}
.breadcrumbs {
  font-size: 14px;
  color: #333;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
}
.breadcrumbs >>> span span {
  color: #0470e3;
  font-weight: bold;
  cursor: default;
}
.results-content {
  margin-top: 15px;
  /*position: relative;*/
  /*padding-right: 235px;*/
}
.results-content >>> .ivu-tabs-bar {
  border-bottom: 0 none;
  margin-bottom: 0;
}
.results-content >>> .ivu-tabs-nav {
  border-color: #eee;
}
.results-content >>> .ivu-tabs-tabbar {
  background-color: #2681ff;
}
.results-content >>> .ivu-tabs-ink-bar {
  height: 1px;
  background-color: #1f8afd;
}
/*.results-content >>> .ivu-tabs-tabpane{*/
/*padding: 0 2px;*/
/*}*/
.results-content >>> .ivu-tabs-tab {
  font-size: 1.4rem;
  color: #999;
  display: none;
}
/*.results-content >>> .ivu-tabs-nav .ivu-tabs-tab:nth-of-type(2){*/
/*padding-right: 0;*/
/*position: relative;*/
/*left: -14px;*/
/*}*/
.results-content >>> .ivu-tabs-tab-active {
  color: #1f8afd;
}
.query-rate {
  display: block;
  color: #fff;
  border: 1px solid #0774b5;
  background-color: #0774b5;
  font-size: 14px;
  border-radius: 3px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  width: 200px;
  text-align: center;
}
.query-rate:hover {
  background-color: #03639c;
  border-color: #03639c;
}
.no_empty {
  padding: 30px 0;
  background-color: #fff;
  /*margin-right: 100px;*/
}
.no_empty img {
  display: block;
  margin: 0 auto;
  width: 240px;
}
.tabs-content {
  padding: 14px 0 16px;
}
.tabs-content >>> .ivu-tabs {
  margin-top: 6px;
}
.tabs-content >>> .ivu-tabs-tab {
  font-size: 15px;
}
.tabs-content >>> .ivu-tabs-ink-bar {
  background-color: #0470e3;
}
.tabs-content >>> .ivu-tabs-tab-active {
  color: #656565;
}
.tabs-content >>> .ivu-tabs-tab:hover {
  color: #0470e3;
}
.tabs-content >>> section {
  margin-top: 5px;
  padding: 0 18px;
}
.caption {
  color: #333;
  background: url("~@/assets/images/home/guide.png") 0 center no-repeat
    transparent;
  background-size: 12px;
  padding-left: 18px;
  margin-bottom: 15px;
  position: relative;
  font-size: 16px;
}
.caption .desc {
  font-size: 1.4rem;
  font-weight: normal;
  color: #999;
  padding-left: 20px;
}
.cell {
  padding: 0 13px;
  font-size: 14px;
}
.number-list {
  font-size: 14px;
  color: #333;
}
.number-list li {
  margin-bottom: 15px;
  position: relative;
  padding-left: 20px;
}
.number-list li:last-child {
  margin-bottom: 0;
}
.number-list .sn {
  background-color: #f09a13;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 100px;
  line-height: 15px;
  text-align: center;
  color: #fff;
  font-size: 10px;
  position: absolute;
  top: 3px;
  left: 0;
}
.number-list .desc {
  margin-top: 2px;
  font-size: 14px;
  color: #999;
}
.results-content >>> .ivu-tabs {
  margin-left: -4px;
  margin-right: -4px;
}
.inputs-wrap {
  background-color: #fff;
  padding: 12px 0 20px;
  border-radius: 3px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.query-tp {
  background-color: #fff;
  margin-bottom: 30px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.query-tp >>> .ivu-tabs .ivu-tabs-bar {
  border-bottom-width: 0.5px;
  margin-bottom: 0;
}
.query-tp >>> .ivu-tabs .ivu-tabs-ink-bar {
  background-color: #0470e3;
  height: 3px;
  width: 145px !important;
}
.query-tp >>> .ivu-tabs .ivu-tabs-tab:hover {
  color: #0470e3;
}
.query-tp >>> .ivu-tabs .ivu-tabs-tab,
.query-tp >>> .ivu-tabs .ivu-tabs-tab-active {
  color: #656565;
  font-size: 16px;
  padding: 8px 30px;
}
.query-tp >>> .ivu-tabs .ivu-icon-logo-tux,
.query-tp >>> .ivu-tabs .ivu-icon-logo-windows {
  font-family: inherit;
  background: url("~@/assets/images/home/ai1.png") 0 center no-repeat
    transparent;
  background-size: 14px;
  width: 16px;
  height: 16px;
  position: relative;
  top: 3px;
  margin-right: 0;
}
.query-tp >>> .ivu-tabs .ivu-icon-logo-windows {
  background-image: url("~@/assets/images/home/ai2.png");
}
</style>




// WEBPACK FOOTER //
// src/components/query/Rules.vue